import { createSelector } from 'reselect';
import extractRouteThreadId from '@/redux/selectors/pieveSelectors/lib/extractRouteThreadId.js';
import isHomeRoute from '@/redux/selectors/pieveSelectors/lib/isHomeRoute.js';

const storedActiveThreadId = (state) => String(state?.ui?.activeThreadId || '').trim() || null;

export const isDraftThreadActive = (state) => {
  const threadId = String(state?.ui?.activeThreadId || '').trim();
  const currentPathname = String(state?.router?.location?.pathname || '').replace(/\/+$/, '') || '/';
  return !threadId && currentPathname === '/new';
};

const routeThreadId = (state) => {
  const pathname = String(state?.router?.location?.pathname || '');
  return extractRouteThreadId({ pathname });
};

export const activeThreadId = createSelector([isDraftThreadActive, isHomeRoute, routeThreadId, storedActiveThreadId], (isDraftThreadActiveValue, isHomeRouteValue, routeThreadIdValue, storedThreadIdValue) => {
  if (isDraftThreadActiveValue || isHomeRouteValue) {
    return null;
  }

  return routeThreadIdValue || storedThreadIdValue || null;
});
